import type { MenuProps } from 'antd';

type MenuItem = Required<MenuProps>['items'][number];

export const findFirstMenuItemKey = (menuItems: MenuItem[]): string => {
  for (const item of menuItems) {
    if (!item) continue;

    if (
      !('type' in item) ||
      (item.type !== 'group' && item.type !== 'divider')
    ) {
      return String(item.key);
    }

    if (
      'children' in item &&
      Array.isArray(item.children) &&
      item.children.length > 0
    ) {
      const childKey = findFirstMenuItemKey(item.children);
      if (childKey) return childKey;
    }
  }
  return '';
};
